const selectPipelineReport = state => state.tableConfig;
export default selectPipelineReport;
